<template>
  <div class="personal-data">
    <h4 class="personal-data__title title">Dados pessoais</h4>
    <form class="personal-data__form grid form" @submit.prevent="handleSubmit">
      <label class="personal-data__user-name form__label form__group--column">
        <span class="form__label-text">Nome completo</span>
        <input
          class="form__input"
          type="text"
          name="name"
          v-model="user.name"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.name === false,
              icon__check : validation.name
            }"
          />
        </span>
      </label>
      <label class="personal-data__user-email form__label form__group--column">
        <span class="form__label-text">E-mail</span>
        <input
          class="form__input"
          type="email"
          name="email"
          v-model="user.email"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.email === false,
              icon__check : validation.email
            }"
          />
        </span>
      </label>
      <div class="personal-data__user-gender form__label form__label--gender">
        <label class="form__label-text form__label-text--gender form__label-text--fullfiled">Gênero</label>
        <div class="form__group--gender">
          <input
            id="male"
            class="form__input--radio"
            type="radio"
            name="gender"
            v-model="user.gender"
            value="M"
            @change="handleUserState"
          />
          <label for="male" class="form__label--radio">M</label>
          <input
            id="female"
            class="form__input--radio"
            type="radio"
            name="gender"
            v-model="user.gender"
            value="F"
            @change="handleUserState"
          />
          <label for="female" class="form__label--radio">F</label>
        </div>
      </div>
      <label class="personal-data__user-birth-date form__label form__group--column">
        <span class="form__label-text form__label-text--fullfiled">Nascido em</span>
        <input
          class="form__input"
          type="tel"
          placeholder="dd/mm/aaaa"
          name="birthDate"
          v-model="user.birthDate"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.birthDate === false,
              icon__check : validation.birthDate
            }"
          />
        </span>
      </label>
      <label class="personal-data__user-height form__label form__group--column">
        <span class="form__label-text">
          Altura
          <wbr />(cm)
        </span>
        <input
          class="form__input"
          type="tel"
          name="height"
          v-model="user.height"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.height === false,
              icon__check : validation.height
            }"
          />
        </span>
      </label>
      <label class="personal-data__user-weight form__label form__group--column">
        <span class="form__label-text">
          Peso
          <wbr />(kg)
        </span>
        <input
          class="form__input"
          type="tel"
          name="weight"
          v-model="user.weight"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.weight === false,
              icon__check : validation.weight
            }"
          />
        </span>
      </label>
      <label class="personal-data__user-has-children form__label--checkbox-column">
        <input
          class="form__input--checkbox"
          type="checkbox"
          id="hasChildren"
          name="hasChildren"
          v-model="user.hasChildren"
          @focus="handleFocus"
          @input="handleInput"
          @change="handleBlur"
        />
        <span class="form__label--checkbox-column-text">Possui filhos?</span>
        <i class="form__label--checkbox-column-icon"></i>
      </label>
      <label
        :class="`personal-data__user-children-quantity form__label form__group--column ${user.hasChildren && 'show'}`"
      >
        <span class="form__label-text">Quantos</span>
        <input
          class="form__input"
          type="number"
          name="childrenQuantity"
          v-model="user.childrenQuantity"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.childrenQuantity === false,
              icon__check : validation.childrenQuantity
            }"
          />
        </span>
      </label>
      <h5 class="personal-data__subtitle subtitle">Documento</h5>
      <label
        class="personal-data__user-document-type form__label form__label--select form__group--column"
      >
        <span class="form__label-text">Tipo</span>
        <select
          class="form__input"
          name="documentType"
          v-model="user.documentType"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        >
          <option value="RG">Identidade</option>
          <option value="CNH">CNH</option>
        </select>
        <span class="form__error-message"></span>
      </label>
      <label class="personal-data__user-document-dispatcher form__label form__group--column">
        <span class="form__label-text">Órgão Expedidor</span>
        <input
          class="form__input"
          type="text"
          name="documentDispatcher"
          v-model="user.documentDispatcher"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.documentDispatcher === false,
              icon__check : validation.documentDispatcher
            }"
          />
        </span>
      </label>
      <label class="personal-data__user-document-number form__label form__group--column">
        <span class="form__label-text">Número</span>
        <input
          class="form__input"
          type="tel"
          name="documentNumber"
          v-model="user.documentNumber"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.documentNumber === false,
              icon__check : validation.documentNumber
            }"
          />
        </span>
      </label>
      <label class="personal-data__user-cpf form__label form__group--column">
        <span class="form__label-text">CPF*</span>
        <input
          class="form__input"
          type="tel"
          name="cpf"
          v-model="user.cpf"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          maxlength="14"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.cpf === false,
              icon__check : validation.cpf
            }"
          />
        </span>
        <span class="form__tip">*Somente números</span>
      </label>
      <label class="personal-data__user-phone form__label form__group--column">
        <span class="form__label-text">Telefone (com DDD)</span>
        <input
          class="form__input"
          type="tel"
          name="phone"
          v-model="user.phone"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.phone === false,
              icon__check : validation.phone
            }"
          />
        </span>
      </label>
      <label
        class="personal-data__user-contact-way form__label form__label--select form__group--column"
      >
        <span class="form__label-text">Melhor forma para contatarmos</span>
        <select
          class="form__input"
          name="contactWay"
          v-model="user.contactWay"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        >
          <option value="Telefone">Telefone</option>
          <option value="WhatsApp">Whats App</option>
          <option value="Email">E-mail</option>
        </select>
        <span class="form__error-message"></span>
      </label>
      <button type="submit" class="personal-data__submit form__submit" aria-label="Botão para seguir em frente no preenchimento do formulário">
        continuar
        <i class="icon__go-ahead" />
      </button>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import cpfValidation from "../../mixins/cpfValidation";
import axios from "axios";
export default {
  name: "PersonalDataForm",
  data() {
    return {
      user: {
        name: "",
        email: "",
        gender: "",
        height: null,
        weight: null,
        birthDate: null,
        hasChildren: false,
        childrenQuantity: 0,
        documentType: "",
        documentDispatcher: "",
        documentNumber: null,
        cpf: null,
        phone: null,
        contactWay: ""
      },
      genderOptions: [
        {
          id: "male",
          name: "gender",
          value: "M"
        },
        {
          id: "female",
          name: "gender",
          value: "F"
        }
      ],
      validation: {
        name: null,
        email: null,
        height: null,
        weight: null,
        birthDate: null,
        childrenQuantity: null,
        documentDispatcher: null,
        documentNumber: null,
        cpf: null,
        phone: null
      }
    };
  },
  computed: {
    ...mapState(["quotation"]),
    ...mapGetters(["getUser"]),
    setInitialBirthDate() {
      const today = new Date();
      return `${today.getFullYear() - 18}-06-15`;
    }
  },
  mixins: [cpfValidation],
  methods: {
    ...mapActions([
      "setUserState",
      "setQuotationStepIncrement",
      "setEmailSent",
      "setLocalSave"
    ]),
    validateAge: function(value) {
      const pattern = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
      const valueSplitted = value.split("").filter(char => char !== "/");
      const slashQty = value.split("").filter(char => char === "/").length;
      if (slashQty < 2) {
        valueSplitted.splice(2, 0, "/");
        valueSplitted.splice(5, 0, "/");
        value = valueSplitted.join("");
      }
      if (pattern.test(value)) {
        const birthDate = new Date(
          value
            .split("/")
            .reverse()
            .join("/")
        );
        const birthDateYear = birthDate.getFullYear();
        const birthDateMonth = birthDate.getMonth() + 1;
        const actualYear = new Date().getFullYear();
        const actualMonth = new Date().getMonth() + 1;
        const ageValid =
          actualYear - birthDateYear > 18 || actualYear - birthDateYear === 18 && actualMonth >= birthDateMonth;
        if (ageValid) {
          return { type: "success", message: "", value };
        } else {
          return { type: "error", message: "A idade mínima é 18 anos", value };
        }
      } else {
        return {
          type: "error",
          message: 'Favor preencher a data no padrão "dd/mm/aaaa"',
          value
        };
      }
    },
    handleUserState(event) {
      const payload = {
        event,
        group: "personalData"
      };
      this.setUserState(payload);
      this.setLocalSave({
        storeItemName: "user",
        storeItemObject: this.quotation.user
      })
    },
    handleFocus: function({ target }) {
      const { previousElementSibling, type } = target;
      if (type !== "checkbox" && type !== "radio") {
        previousElementSibling.classList.add("form__label-text--focus");
      }
    },
    handleInput: function(event) {
      const {
        target: {
          name,
          parentElement,
          previousElementSibling,
          nextElementSibling,
          type,
          validity: { valid }
        }
      } = event;
      if (type !== "checkbox" && type !== "radio") {
        previousElementSibling.classList.add("form__label-text--fullfiled");
        if (valid) {
          parentElement.classList.remove("error");
          nextElementSibling.innerText = "";
        }
      }
    },
    handleBlur: function(event) {
      const {
        target: {
          name,
          parentElement,
          previousElementSibling,
          nextElementSibling,
          type,
          validationMessage,
          validity: { typeMismatch, valid, valueMissing },
          value
        }
      } = event;
      if (type !== "checkbox" && type !== "radio") {
        previousElementSibling.classList.remove("form__label-text--focus");
      }
      if (!valid) {
        this.validation[name] = false;
        if (type === "email" && typeMismatch) {
          nextElementSibling.innerText = "Favor preencher com um e-mail válido";
        } else if (valueMissing) {
          nextElementSibling.innerText = "Campo obrigatório";
        } else if (validationMessage === "Please enter a number.") {
          parentElement.classList.add("error");
          nextElementSibling.innerText = "Por favor insira somente os números";
          document
            .querySelector(".personal-data__submit")
            .setAttribute("disabled", "disabled");
        } else {
          parentElement.classList.remove("error");
          nextElementSibling.innerText = "";
          document
            .querySelector(".personal-data__submit")
            .removeAttribute("disabled");
        }
        parentElement.classList.add("error");
      } else {
        if (valueMissing) {
          previousElementSibling.classList.remove(
            "form__label-text--fullfiled"
          );
        } else if (name === "birthDate") {
          const ageValid = this.validateAge(value);
          parentElement.classList.add(ageValid.type);
          nextElementSibling.innerText = ageValid.message;
          event.target.value = this.user[name] = ageValid.value;
          if (ageValid.type === "error") {
            document
              .querySelector(".personal-data__submit")
              .setAttribute("disabled", "disabled");
          } else {
            document
              .querySelector(".personal-data__submit")
              .removeAttribute("disabled");
            this.handleUserState(event);
            this.validation[name] = true;
          }
        } else if (name === "cpf") {
          this.user.cpf = this.cpfLeftZeros(value);
          this.user.cpf = this.cpfMask(this.user.cpf);
          if (!this.validateCpf(this.user.cpf)) {
            parentElement.classList.add("error");
            nextElementSibling.innerText = "Por favor insira um CPF válido";
            document
              .querySelector(".personal-data__submit")
              .setAttribute("disabled", "disabled");
            this.validation[name] = false;
          } else {
            parentElement.classList.remove("error");
            nextElementSibling.innerText = "";
            document
              .querySelector(".personal-data__submit")
              .removeAttribute("disabled");
            this.handleUserState(event);
            this.validation[name] = true;
          }
        } else {
          this.validation[name] = true;
          this.handleUserState(event);
        }
      }
    },
    handleSubmit: function() {
      const url = location.port
        ? "http://localhost:5000/bralife/us-central1/app/sendLeadEmail"
        : "https://us-central1-bralife.cloudfunctions.net/app/sendLeadEmail";
      const {
        financialData: { protectionsValue, selectedInsurer }
      } = JSON.parse(localStorage.user);
      const emailSent = JSON.parse(localStorage.emailSent);
      const regex = /teste/gi
      const testing = regex.test(this.user.name);

      if (!emailSent && !testing) {
        axios
          .post(url, {
            user: { personalData: this.user },
            simulation: { protectionsValue, selectedInsurer }
          })
          .then(this.setEmailSent(true));
      }
      this.$router.push("/cotacao/endereco");
      this.setQuotationStepIncrement();
    }
  },
  created() {
    this.user.birthDate = this.setInitialBirthDate;
  },
  mounted() {
    if (localStorage.user) {
      const {
        personalData
      } = JSON.parse(localStorage.user);
      for (let field in personalData) {
        this.user[field] = personalData[field];
        const inputRendered = document.querySelector(`[name=${field}]`);
        if (
          inputRendered.type !== "radio" &&
          inputRendered.type !== "checkbox"
        ) {
          inputRendered.previousElementSibling.classList.add(
            "form__label-text--fullfiled"
          );
        }
      }
    }
  }
};
</script>

<style lang="scss">
.personal-data {
  @include fade-in;
  animation-delay: 0.2s;

  &__title {
    margin-bottom: $space__lg;
  }

  &__subtitle {
    grid-area: subtitle;
    margin-bottom: $space__st;
    font-size: $font-size__st;
  }

  &__form {
    grid-template-areas:
      "name name name"
      "email email email"
      "gender birth-date birth-date"
      "height weight weight"
      "has-children children-quantity children-quantity"
      "subtitle subtitle subtitle"
      "document-type document-dispatcher document-dispatcher"
      "document-number document-number document-number"
      "cpf cpf cpf"
      "phone phone phone"
      "contact-way contact-way contact-way"
      "submit submit submit";

    @include breakpoint($tablet__min--sm) {
      grid-template-areas:
        "name email gender"
        "birth-date height weight"
        "has-children children-quantity ."
        "subtitle subtitle subtitle"
        "document-type document-dispatcher document-number"
        "cpf phone contact-way"
        ". submit .";
    }

    @include breakpoint($desk__min--sm) {
      grid-template-areas:
        "name email gender birth-date birth-date"
        "height weight has-children children-quantity ."
        "subtitle subtitle subtitle subtitle subtitle"
        "document-type document-dispatcher document-number . ."
        "cpf phone contact-way . ."
        ". . submit . .";
    }
  }

  &__user {
    &-name {
      grid-area: name;
    }

    &-email {
      grid-area: email;
    }

    &-gender {
      grid-area: gender;
    }

    &-height {
      grid-area: height;
    }

    &-weight {
      grid-area: weight;
    }

    &-birth-date {
      grid-area: birth-date;
    }

    &-has-children {
      grid-area: has-children;
    }

    &-children-quantity {
      opacity: 0;
      visibility: hidden;

      &.show {
        grid-area: children-quantity;
        @include fade-in(500ms);

        .form__label-text {
          left: 0;

          &:after {
            content: "?";
          }
        }
      }
    }

    &-document-type {
      grid-area: document-type;
    }

    &-document-dispatcher {
      grid-area: document-dispatcher;
    }

    &-document-number {
      grid-area: document-number;
    }

    &-cpf {
      grid-area: cpf;
    }

    &-phone {
      grid-area: phone;
    }

    &-contact-way {
      grid-area: contact-way;
    }
  }

  &__submit {
    position: relative;
    grid-area: submit;

    &:disabled {
      background-color: $color__gray;
    }

    .icon__go-ahead {
      position: absolute;
      top: 50%;
      right: $space__st;
      transform: translateY(-50%);
    }
  }
}
</style>
